/* Copyright (c) 2025 Xperi. All Rights Reserved. */
import React, { FunctionComponent } from 'react';

import { RecordingStatus as PreviewRecordingStatus } from 'client-code/previews';
import { RecordingStatus } from 'client-code/recordings-status';

import { ServicesClientImpl } from '../../../core/interactors';

type RecordingStatusProps = {
    type: string;
    styleClass?: string;
};

export const RECORDING_TYPE = {
    GuidePreviewCompleteRecording: PreviewRecordingStatus.CompleteRecording,
    InProgressRecording: RecordingStatus.InProgressRecording,
    ScheduledAsOnePass: RecordingStatus.ScheduledAsOnePass,
    ScheduledAsSingleExplicit: RecordingStatus.ScheduledAsSingleExplicit,
};

const imageAssets = {
    ICON_STATUS_ONEPASS: 'ICON_STATUS_ONEPASS',
    RECORDING_NOW_ICON: 'RECORDING_NOW_ICON',
    SINGLE_EXPLICIT_RECORD_ICON: 'SINGLE_EXPLICIT_RECORD_ICON',
    ON_DISK_ICON: 'ON_DISK_ICON',
};

const RecordingStatusIcon: FunctionComponent<RecordingStatusProps> = ({
    type,
    styleClass,
}): JSX.Element => {
    const services = new ServicesClientImpl();

    const getStatusIcon = () => {
        let statusIcon;
        switch (type) {
            case RECORDING_TYPE.GuidePreviewCompleteRecording:
                statusIcon = services.getAppUiImageByKey(imageAssets.ON_DISK_ICON);
                break;
            case RECORDING_TYPE.InProgressRecording:
                statusIcon = services.getAppUiImageByKey(imageAssets.RECORDING_NOW_ICON);
                break;
            case RECORDING_TYPE.ScheduledAsOnePass:
                statusIcon = services.getAppUiImageByKey(imageAssets.ICON_STATUS_ONEPASS);
                break;
            case RECORDING_TYPE.ScheduledAsSingleExplicit:
                statusIcon = services.getAppUiImageByKey(imageAssets.SINGLE_EXPLICIT_RECORD_ICON);
                break;
            default:
        }
        return statusIcon?.imageUrl ?? '';
    };
    const renderStatusIcon = () => {
        return <img src={getStatusIcon()} alt="" className={styleClass ?? ''} />;
    };

    return <>{renderStatusIcon()}</>;
};

export default RecordingStatusIcon;
